import React from 'react';

import styles from './styles.module.css';
import { LocationFormData } from '@/hooks/services/Locations';

interface DataPointTableProps {
  formData: LocationFormData;
  handleDataPointChange: (dataPoint: string, value: boolean) => void;
  dataPointsLabels?: Record<string, string>;
}

const DataPointTable = ({
  formData,
  handleDataPointChange,
  dataPointsLabels
}: DataPointTableProps) => {
  if (!dataPointsLabels) {
    return null;
  }

  const dataPointsEntries = Object.entries(dataPointsLabels);
  const dataPointsPerRow = 5;

  const rows: Array<Array<[string, string]>> = [];
  for (let i = 0; i < dataPointsEntries.length; i += dataPointsPerRow) {
    rows.push(
      dataPointsEntries.slice(i, i + dataPointsPerRow) as Array<
        [string, string]
      >
    );
  }

  return (
    <table className={styles.dataTable}>
      <thead>
        <tr>
          {Array.from({ length: dataPointsPerRow }, (_, index) => (
            <React.Fragment key={index}>
              <th className={styles.tableHeaderSwitch}>
                <div className={styles.headerText}>
                  <span id={`on-off-label`} className={styles.onOffLabel}>
                    ON/OFF
                  </span>
                </div>
              </th>
              <th className={styles.tableHeaderDataPoint}>
                <div className={styles.headerText}>
                  <span
                    id={`data-point-label`}
                    className={styles.dataPointLabel}
                  >
                    DATA POINT
                  </span>
                </div>
              </th>
              {index < dataPointsPerRow - 1 && (
                <th className={styles.tableHeaderSpacer}></th>
              )}
            </React.Fragment>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map((rowData, rowIndex) => (
          <tr
            key={rowIndex}
            className={rowIndex % 2 === 0 ? styles.evenRow : styles.oddRow}
          >
            {rowData.map(([key, label], dataPointIndex) => (
              <React.Fragment key={key}>
                <td className={styles.tableCellSwitch}>
                  <label className={styles.toggleSwitch}>
                    <input
                      id={`${key}-toggle-input`}
                      type="checkbox"
                      checked={formData.dataPoints[key] || false}
                      onChange={e =>
                        handleDataPointChange(key, e.target.checked)
                      }
                      className={styles.toggleInput}
                    />
                    <span className={styles.toggleSlider}></span>
                  </label>
                </td>
                <td className={styles.tableCellDataPoint}>
                  <span
                    id={`${label}-data-point-text`}
                    className={styles.dataPointText}
                  >
                    {label}
                  </span>
                </td>
                {dataPointIndex < rowData.length - 1 && (
                  <td className={styles.tableCellSpacer}></td>
                )}
              </React.Fragment>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default DataPointTable;
